/**
 * @Author: 
 * @Description: 
 * @DateTime: Created in 2020-11-14 09:25:32
 */

import { Component, Watch } from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import SoftwareSecretKeyService, { test } from "./service/softwareSecretKeyService"
import Tab from 'src/components/tab/tab';
import { createBEM, createNamespace } from 'src/util/bem';
import * as Vue from 'vue-tsx-support';
import FrameContentBg from 'src/pages/layout/components/frameContentBg';
import IconCustom from 'src/components/icon/iconCustom';
import './softwareSecretKey.less'
import Input from 'src/types/iview/Input';
import InputNumber from 'src/types/iview/InputNumber';
import { Integer } from 'src/types/base';
import softwareSecretKeyApi from './api/softwareSecretKeyApi';
import Button from 'src/types/iview/Button';
let bem = createBEM('menu-btn');
let newBem = createBEM('software-secretKey');
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import DatePicker from 'src/types/iview/DatePicker';
import serialNumberLogModal from './serialNumberLogModal';


@Component({ name: 'software-secretKey' })
export default class SoftwareSecretKey extends Vue.Component<>{
    tabs: { name: string; value: string | number }[] = [{ name: '秘钥一', value: 1 }, { name: '秘钥二', value: 2 }, { name: '秘钥三', value: 3 }, { name: '注册码', value: 4 },
    { name: '新注册码', value: 5 },{ name: '序列号', value: 6 }];
    types = 1;
    rules: any = {};
    formData: {
        dc: "",
        ckb: 0,
        pw1: "",
        pw2: "",
        time: 1
    }
    //密钥一
    key: string = "";
    dc: string = "";
    ckb: Integer = 0;
    pw1: string = "";
    pw2: string = "";
    time: Integer = 1;
    //密钥二
    hour: Integer = 0;
    min: Integer = 0;
    month: Integer = 1;
    dataSource: Array<{ id: number, name: string }> = [
        { id: 1, name: '1' },
        { id: 3, name: '3' },
        { id: 6, name: '6' },
        { id: 9, name: '9' },
        { id: 12, name: '12' },
        { id: 15, name: '15' },
        { id: 18, name: '18' },
        { id: 24, name: '24' },
        { id: 36, name: '36' },
        { id: 48, name: '48' },
        { id: 60, name: '60' }
    ]
    // 密钥三
    mn: string = "";
    hmi: string = "";
    type: Integer = 2;
    typeDataSource: Array<{ id: number, name: string }> = [
        { id: 2, name: '模式二' },
        { id: 3, name: '模式三' },
    ]
    // 注册码
    datetime: string = "";
    registration: string = ""
    macAddress: string = ""
    siteType: string = ""
    siteTypeDataSource: Array<{ id: string, name: string }> = [
        { id: 'SZXT', name: '水站' },
        { id: 'NWDP', name: '投屏软件' },
    ]
    // 新注册码
    cpucode: string = "";
    newSiteType:number = null;
    newSiteTypeDataSource: Array<{ id: string, name: string }> = [
        { id: 1, name: '水站工控机' },
        { id: 2, name: '污染源上位机' },
    ]
    //序列号
    newcpucode: string = "";
    //newSiteTypes:number = null;

    typeChnage(v) {
        this.key = "";
        this.types = v;
    }

    async save() {
        switch (this.types) {
            case 1:
                let { code, data } = await softwareSecretKeyApi.getSecretKey({
                    ckb: this.ckb,
                    dc: this.dc,
                    pw1: this.pw1,
                    pw2: this.pw2,
                    time: this.time
                });
                if (code === 0) {
                    this.key = data.secret_key;
                }
                break;
            case 2:
                let { code, data } = await softwareSecretKeyApi.getModeOne({
                    hour: this.hour,
                    min: this.min,
                    month: this.month
                });
                if (code === 0) {
                    this.key = data.secret_key;
                }
                break;
            case 3:
                let { code, data } = await softwareSecretKeyApi.getModeTwo({
                    hmi: this.hmi,
                    mn: this.mn,
                    month: this.month,
                    type: this.type,
                });
                if (code === 0) {
                    this.key = data.secret_key;
                }
                break;
            case 4:
                let { code, data } = await softwareSecretKeyApi.registrationcode({
                    datetime: this.datetime,
                    registration: this.siteType + this.macAddress,
                });
                if (code === 0) {
                    this.key = data.secret_key;
                }
                break;
            case 5:
                var xstr = this.cpucode.substring(this.cpucode.length - 6, this.cpucode.length - 3);
                var ystr = this.cpucode.substring(this.cpucode.length - 3, this.cpucode.length);
                var zstr = ""
                if(this.newSiteType == 1){
                    zstr = (parseInt(xstr, 16) * parseInt(ystr, 16) * 3.1415926).toString();
                }
                else
                {
                    zstr = (parseInt(xstr, 16) * parseInt(ystr, 16)).toString();
                }
                var origz = zstr.replace(".", "");
                while (zstr.length < 6)
                {
                    zstr = "0" + zstr;
                }
                this.key = origz.substring(0, 4) + "AA" + zstr.substring(zstr.length - 6, zstr.length);
                break
            case 6:
                var xstr = this.newcpucode.substring(this.newcpucode.length - 6, this.newcpucode.length - 3);
                var ystr = this.newcpucode.substring(this.newcpucode.length - 3, this.newcpucode.length);
                var zstr = ""
                zstr = (parseInt(xstr, 16) * parseInt(ystr, 16) * 5.1415926).toString();
                var origz = zstr.replace(".", "");
                while (zstr.length < 6)
                {
                    zstr = "0" + zstr;
                }
                var key = origz.substring(0, 4) + "AA" + zstr.substring(zstr.length - 6, zstr.length);
                let { code, data } = await softwareSecretKeyApi.getSerialNumber({
                    cpucode: this.newcpucode,
                    serial_number:key,
                });
                if (code === 0) {
                    this.key = key
                } 
                break
        }
    }

    render(h) {
        return (
            <layout class={bem()}>
                <i-content class={bem('content') + ' ' + createNamespace('pa6')}>
                    <div>
                        <Tab dataSource={this.tabs} value={this.types} on-input={this.typeChnage.bind(this)} style="display:inline-block" />
                    </div>
                    <FrameContentBg showCorner={false} radius={true} class={createNamespace('mt5')}>
                        <div class={newBem('onebox')}>
                            <i-form v-if={this.types == 1} class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                                <form-item label="请输入DC" prop="dc" >
                                    <Input v-model={this.dc} placeholder="请输入DC" />
                                </form-item>
                                <form-item label="请输入ckb" prop="ckb" >
                                    <InputNumber v-model={this.ckb} max={10000000000} placeholder="请输入ckb" />
                                </form-item>
                                <form-item label="请输入pw1" prop="pw1" >
                                    <Input v-model={this.pw1} placeholder="请输入pw1" />
                                </form-item>
                                <form-item label="请输入pw2" prop="pw2" >
                                    <Input v-model={this.pw2} placeholder="请输入pw2" />
                                </form-item>
                                <form-item label="请输入时长" prop="time" >
                                    <InputNumber v-model={this.time} max={60} placeholder="请输入时长" />
                                </form-item>
                                <p class={newBem('k')} style="margin-left: 65px;" v-show={this.key != ""}>{this.key}</p>
                                <Button type="primary" on-click={this.save} style="margin-left: 120px;">
                                    确认
                                </Button>
                            </i-form>
                            <i-form v-if={this.types == 2} class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                                <form-item label="请输入开始小时" prop="hour" >
                                    <InputNumber v-model={this.hour} max={23} placeholder="" />
                                </form-item>
                                <form-item label="请输入开始分钟" prop="min" >
                                    <InputNumber v-model={this.min} max={59} placeholder="" />
                                </form-item>
                                <form-item label="时长" prop="month" type="number">
                                    <CommonSelect dataSource={this.dataSource} v-model={this.month} />
                                </form-item>
                                <p class={newBem('k')} style="margin-left: 65px;" v-show={this.key != ""}>{this.key}</p>
                                <Button type="primary" on-click={this.save} style="margin-left: 120px;">
                                    确认
                                </Button>
                            </i-form>
                            <i-form v-if={this.types == 3} class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                                <form-item label="请输入设备编号" prop="mn" >
                                    <Input v-model={this.mn} placeholder="请输入设备编号" />
                                </form-item>
                                <form-item label="请输入HMI编号" prop="hmi" >
                                    <Input v-model={this.hmi} placeholder="请输入HMI编号" />
                                </form-item>
                                <form-item label="时长" prop="month" type="number">
                                    <CommonSelect dataSource={this.dataSource} v-model={this.month} />
                                </form-item>
                                <form-item label="请输入类型" prop="type" type="number">
                                    <CommonSelect dataSource={this.typeDataSource} v-model={this.type} />
                                </form-item>
                                <p class={newBem('k')} style="margin-left: 65px;" v-show={this.key != ""}>{this.key}</p>
                                <Button type="primary" on-click={this.save} style="margin-left: 120px;">
                                    确认
                                </Button>
                            </i-form>
                            <i-form v-if={this.types == 4} class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                                <form-item label="请输入Mac地址" prop="macAddress" >
                                    <Input v-model={this.macAddress} placeholder="请输入Mac地址" />
                                </form-item>
                                <form-item label="请输入当前时间" prop="datetime" >
                                    <DatePicker format={"yyyy-MM-dd"} type={"datetime"} placeholder="请输入当前时间" v-model={this.datetime}></DatePicker>
                                </form-item>
                                <form-item label="请输入站点类型" prop="siteType" type="number">
                                    <CommonSelect dataSource={this.siteTypeDataSource} v-model={this.siteType} />
                                </form-item>
                                <p class={newBem('k')} style="margin-left: 65px;" v-show={this.key != ""}>{this.key}</p>
                                <Button type="primary" on-click={this.save} style="margin-left: 120px;">
                                    确认
                                </Button>
                            </i-form>
                            <i-form v-if={this.types == 5} class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                                <form-item label="请输入CPU编号"  prop="cpucode" >
                                    <Input v-model={this.cpucode} placeholder="请输入CPU编号" />
                                </form-item>
                                <form-item label="请选择站点类型" prop="newSiteType" type="number">
                                    <CommonSelect dataSource={this.newSiteTypeDataSource} v-model={this.newSiteType} />
                                </form-item>
                                <p class={newBem('k')} style="margin-left: 65px;" v-show={this.key != ""}>{this.key}</p>
                                <Button type="primary" on-click={this.save} style="margin-left: 120px;">
                                    确认
                                </Button>
                            </i-form>
                            <i-form v-if={this.types == 6} class={createNamespace('mt20')} ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                                <form-item label="请输入CPU编号"  prop="cpucode" >
                                    <Input v-model={this.newcpucode} placeholder="请输入CPU编号" />
                                </form-item>
                                <p class={newBem('k')} style="margin-left: 65px;" v-show={this.key != ""}>{this.key}</p>
                                <Button type="primary" on-click={this.save} style="margin-left: 120px;">
                                    确认
                                </Button>
                                <Button class={createNamespace('ml20 mr10')} type="primary" onClick={() => serialNumberLogModal()}>
                                    序列号日志
                                </Button>
                            </i-form>
                        </div>
                    </FrameContentBg>
                </i-content>
            </layout>
        );
    }
}